// @flow

import styles from './ContentSpacer.less';

import { connect } from 'react-redux';
import { createSelector } from 'reselect';
import classnames from 'classnames';
import React, { Component } from 'react';

import { isSearchResultsPath } from '@seek/seek-jobs-seo';

type PanelsTypes = 'dashboard' | 'refinebar' | 'searchbar';

type Props = {
  isSlider?: boolean,
  children?: any,
  trigger?: PanelsTypes | Array<PanelsTypes>,
  dashboardExpand: boolean,
  isHomepage: boolean,
  pathname: string,
  activeRefinement?: string,
  authenticated: boolean
};

class ContentSpacer extends Component<Props> {
  props: Props;

  shouldSlide = (triggerName: PanelsTypes, condition: boolean) => {
    const { trigger } = this.props;

    return (
      trigger &&
      (triggerName === trigger || trigger.indexOf(triggerName) > -1) &&
      condition
    );
  };

  shouldAddClass = (triggerName: PanelsTypes, condition: boolean) => {
    const { isSlider } = this.props;

    return isSlider ? this.shouldSlide(triggerName, condition) : condition;
  };

  render() {
    const {
      activeRefinement,
      children,
      dashboardExpand,
      isHomepage,
      isSlider,
      pathname,
      authenticated
    } = this.props;

    const { shouldAddClass } = this;

    const dashboardIsOpen = authenticated && isHomepage && dashboardExpand;
    const isSearchPage = isSearchResultsPath(pathname);
    const datelistedIsOpen = isSearchPage && activeRefinement === 'DateListed';
    const salaryIsOpen =
      isSearchPage &&
      (activeRefinement === 'SalaryFrom' || activeRefinement === 'SalaryTo');
    const searchbarIsCollapsed = isSearchPage;
    const searchbarIsExpanded = isHomepage;
    const worktypeIsOpen = isSearchPage && activeRefinement === 'WorkType';

    const rootClasses = classnames({
      [styles[`root_${isSlider ? 'slider' : 'spacer'}`]]: true,
      [styles.dashboard_isOpen]: shouldAddClass('dashboard', dashboardIsOpen),
      [styles.worktype_isOpen]: shouldAddClass('refinebar', worktypeIsOpen),
      [styles.salary_isOpen]: shouldAddClass('refinebar', salaryIsOpen),
      [styles.datelisted_isOpen]: shouldAddClass('refinebar', datelistedIsOpen),
      [styles.searchbar_isExpanded]: shouldAddClass(
        'searchbar',
        searchbarIsExpanded
      ),
      [styles.searchbar_isCollapsed]: shouldAddClass(
        'searchbar',
        searchbarIsCollapsed
      )
    });

    return <div className={rootClasses}>{children}</div>;
  }
}

const mapStateToProps = () =>
  createSelector(
    state => state.dashboard.expand,
    state => state.location.isHomepage,
    state => state.location.pathname,
    state => state.search.activeRefinement,
    state => state.user.authenticated,

    (
      dashboardExpand,
      isHomepage,
      pathname,
      activeRefinement,
      authenticated
    ) => ({
      dashboardExpand,
      isHomepage,
      pathname,
      activeRefinement,
      authenticated
    })
  );

export default connect(mapStateToProps)(ContentSpacer);
export { ContentSpacer as ContentSpacerForTest };
